import { Page } from "./util";
import CodeMirror from '@uiw/react-codemirror';
import 'codemirror/keymap/sublime';
// import 'codemirror/theme/monokai.css';
import './cmtheme.css';
import { useRef, useState } from "react";
import $ from 'jquery'
import MDEditor from "@uiw/react-md-editor";

const Test = () => {
	const md = useRef("")
	const myRef = useRef(null)
	const [colapsed, setcolapsed] = useState(true);
	return (
		<Page className="test">
			<div className="codemirrorcontainer">
				<div className="navpad h50"></div>
				<div 
					ref={myRef}
					style={{
						// maxHeight: "100px",
						// overflowY: "auto"
					}}
				>
					<CodeMirror
						height={colapsed ? "auto" : 500}
						className="testing"
						value={md.current}
						options={{
							theme: colapsed ? 'dracula colapsed' : 'dracula notcolapsed',
							// keyMap: 'sublime',
							lineWrapping: true,
							mode: 'markdown',
							onKeyEvent: () => {
								console.log("test")
							}
						}}
						onChange={(a, b, c) => {
							// console.log({ a, b, c })
							// console.log(JSON.stringify(a, getCircularReplacer()))
							console.log({ a, b })
							// console.log(a.doc.getValue())
							md.current = a.doc.getValue()
							console.log(md.current)
						}}
					/>
				</div>
			</div>
		</Page>
	);
}

export default Test;
